<main>
	<div class="content-wrapper">
		<div class="login-card card-container">
			<div *ngIf="logoPath" class="text--center">
				<img [src]="logoPath" [alt]="logoAltTag" class="image__card" data-cy="login__logoImage" />
			</div>
			<div class="hide-element" role="heading" aria-level="2">{{pageHeading}}</div>
			<router-outlet></router-outlet>
		</div>
	</div>
	<ahp-swap-language
		class="login__swap-language"
		[isSideNav]="false"
	></ahp-swap-language>
</main>

<ahp-login-footer role="contentinfo" class="footer"></ahp-login-footer>
